export class NpSummaryModel {

    public id: number;
    public firstName: string;
    public lastName: string;
    public email: string;
    public phone: string;
    public countryId: number;

    constructor(obj?: any) {
        this.id                 = obj && obj.id                 || null;
        this.firstName          = obj && obj.firstName          || '';
        this.lastName           = obj && obj.lastName           || '';
        this.email              = obj && obj.email              || '';
        this.phone              = obj && obj.phone              || '';
        this.countryId          = obj && obj.countryId          || null;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/np-summary.model.ts